import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-wide transition-colors duration-200 shadow-sm',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/90',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/90',
        destructive: 'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border-border text-foreground hover:bg-accent/50',
        success: 'border-[oklch(0.65_0.15_130)]/25 bg-[oklch(0.65_0.15_130)]/8 text-[oklch(0.45_0.12_130)] shadow-none',
        warning: 'border-[oklch(0.70_0.15_50)]/25 bg-[oklch(0.70_0.15_50)]/8 text-[oklch(0.52_0.12_50)] shadow-none',
        info: 'border-[oklch(0.65_0.15_130)]/20 bg-[oklch(0.65_0.15_130)]/6 text-[oklch(0.45_0.12_130)] shadow-none',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}
export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}
